<input-information>
  <style>
    .sec-basic-input__item__birth .input-text {
      width: 4em;
    }
    .sec-basic-input__item__birth .input-text.year {
      width: 6em;
    }
    .sec-basic-input__item__birth .input-text.country {
      width: 240px;
    }
    .sec-basic-input__item__birth .com-form__item__input.input-text + span {
      margin-left: .5em;
    }
  </style>
  <section class="sec-top-function com-bg-gray">
    <div class="sec-top-inner sec-inner">
      <header class="sec-top-header">
        <h2 class="sec-top__ttl"><span>本登録</span></h2>
        <p>
          メールアドレスの認証が完了しました。
          続けて下記の必要情報を入力して、本登録を終えてください。
        </p>
        <p>
          尚、24時間以内に本登録が完了しない場合は、メールアドレスの認証は無効になります。
          無効になってから再登録を行う場合は、始めの認証コード確認からやり直してください。
        </p>
        <p style="color: red;">
          本画面にてご登録いただく名前が公開されることはありません。登録完了後にポートフォリオごとにお好きな名前・ペンネームでの設定が可能です
        </p>
      </header>
    </div>
  </section>

  <div class="com-article-inner">
    <div class="sec-inner">
      <div class="sec-basic-input__wrap com-bg-white">
        <section class="sec-basic-input">
          <div class="com-form">
            <form>
              <div class="com-form__item">
                <p class="com-form__item__caption"><span>メールアドレス</span></p>
                <div class="com-form__item__content">
                  <div class="com-form__item__input input-text">
                    {mail}
                  </div>
                </div>
              </div>

              <div class="com-form__item">
                <p class="com-form__item__caption"><span>名前（姓）</span><i class="icon-require">必須</i></p>
                <div class="com-form__item__content">
                  <div class="com-form__item__input input-text short">
                    <input type="text" name="familyName" autocomplete="family-name" is="edireco-binding" data="{data}" validate="string" placeholder="姓" errMsg="姓を入力して下さい" required>
                  </div>
                </div>
              </div>
             <div class="com-form__item">
                <p class="com-form__item__caption"><span>名前（名）</span><i class="icon-require">必須</i></p>
                <div class="com-form__item__content">
                  <div class="com-form__item__input input-text short">
                    <input type="text" name="firstName" autocomplete="given-name" is="edireco-binding" data="{data}" validate="string" placeholder="名" errMsg="名を入力して下さい" required>
                  </div>
                </div>
              </div>

              <div class="com-form__item">
                <p class="com-form__item__caption"><span>フリガナ（セイ）</span><i class="icon-require">必須</i></p>
                <div class="com-form__item__content">
                  <div class="com-form__item__input input-text short">
                    <input type="text" name="familyKana" is="edireco-binding" data="{data}" validate="string" placeholder="セイ" errMsg="セイを入力して下さい" required>
                  </div>
                </div>
              </div>

              <div class="com-form__item">
                <p class="com-form__item__caption"><span>フリガナ（メイ）</span><i class="icon-require">必須</i></p>
                <div class="com-form__item__content">
                  <div class="com-form__item__input input-text short">
                    <input type="text" name="firstKana" is="edireco-binding" data="{data}" validate="string" placeholder="メイ" errMsg="メイを入力して下さい" required>
                  </div>
                </div>
              </div>

              <div class="com-form__item">
                <p class="com-form__item__caption"><span>性別</span><i class="icon-require">必須</i></p>
                <div class="com-form__item__content">
                  <div class="com-form__item__input input-radio">
                    <ul>
                      <li each={idx in Object.keys(sexList)}>
                        <input type="radio" name="sex" id="sex-{idx}" is="edireco-binding" data="{data}" val="{idx}" required><label for="sex-{idx}">{sexList[idx]}</label>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="com-form__item">
                <p class="com-form__item__caption"><span>生年月日</span><i class="icon-require">必須</i></p>
                <div class="com-form__item__content">
                  <ul class="sec-basic-input__item__birth">
                    <li>
                      <div class="com-form__item__input input-text year">
                        <input type="text" name="birthYear" autocomplete="bday-year" is="binding" data="{data}" placeholder="年" required>
                      </div>
                      <span>年</span>
                    </li>
                    <li>
                      <div class="com-form__item__input input-text">
                        <input type="text" name="birthMonth" autocomplete="bday-month" is="binding" data="{data}" placeholder="月" required>
                      </div>
                      <span>月</span>
                    </li>
                    <li>
                      <div class="com-form__item__input input-text">
                        <input type="text" name="birthDay" autocomplete="bday-day" is="binding" data="{data}" placeholder="日" required>
                      </div>
                      <span>日</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="com-form__item">
                <p class="com-form__item__caption"><span>居住地</span><i class="icon-require">必須</i></p>
                <div class="com-form__item__content">
                  <ul class="sec-basic-input__item__birth">
                    <li>
                      <div class="com-form__item__input input-select">
                        <select name="pref" autocomplete="address-level1" onchange="{ onChangeSelect }" placeholder="都道府県" errMsg="居住地を選択してください" required>
                          <option value="">--</option>
                          <option value="{pref.id}" each={pref in prefs()}>{pref.jname}</option>
                        </select>
                      </div>
                    </li>
                    <li>
                      <div class="com-form__item__input input-text country">
                        <input
                          type="{ data.pref==48 ? 'text' : 'hidden' }"
                          is="binding"
                          name="country"
                          data="{data}"
                          placeholder="国名を入力してください"
                          errMsg="国名を入力してください"
                        >
                      </div>
                    </li>
                  </ul>
                </div>
              </div>


              <div class="com-form__item">
                <p class="com-form__item__caption"><span>ログインパスワード<br /><span style="font-size:small;font-weight: normal;">（8～32文字で半角英数のみ）</span></span><i class="icon-require">必須</i></p>
                <div class="com-form__item__content">
                  <div class="com-form__item__input input-text">
                    <input type="password" name="password" autocomplete="new-password" data="{data}" is="edireco-binding" validate="string" placeholder="パスワードを入力してください" errMsg="パスワードを入力してください" required>
                  </div>
                </div>
              </div>

              <div class="com-form__item ">
                <p class="com-form__item__caption"><span>ログインパスワード（確認用）</span><i class="icon-require">必須</i></p>
                <div class="com-form__item__content">
                  <div class="com-form__item__input input-text">
                    <input type="password" name="password2" autocomplete="new-password" data="{data}" is="edireco-binding" validate="string" placeholder="パスワード（確認用）を入力してください" errMsg="パスワード（確認用）を入力してください" required>
                  </div>
                </div>
              </div>

              <div class="com-form__submit">
                <button type="button" class="com-btn-01" onclick="{dump}"><span>確認画面へ</span></button>
              </div>
            </form>

          </div>

        </section>
        <!-- End .sec-basic-input -->
      </div>
    </div>
  </div>

  <script>
    import di from 'dependeny-injection'
    import { fullToHalf, validateBirthday } from '@lib/utils.js'

    export default {
      mail: di.register.masked_mail,
      data: di.register.coreData,
      sexList: di.register.sexList,
      onMounted(){
        scrollTo(0, 0);
        if (di.register.secondCode === false) {
          di.route.router.push("/confirm-code");
          return;
        }

        //戻れなくする
        di.register.lockUnload();
        
        this.mail = di.register.masked_mail;
        this.update();
      },
      dump(e) {
        e.preventDefault();

        let pass = this.data.validate();
        if (
          !di.register.customValid(
            this,
            di.register.validatePref(
              this.data.pref,
              this.data.country
            )
          )
        ) {
          pass = false;
        }
        // 全角 -> 半角
        this.data.birthYear = fullToHalf(this.data.birthYear);
        this.data.birthMonth = fullToHalf(this.data.birthMonth);
        this.data.birthDay = fullToHalf(this.data.birthDay);

        if (
          !di.register.customValid(
            this,
            validateBirthday(
              this.data.birthYear,
              this.data.birthMonth,
              this.data.birthDay
            )
          )
        ) {
          pass = false;
        }
        if (pass) {
          let v = this.data.toData();
          if (! /^[0-9a-zA-Z]{8,32}$/.test(v.password)) {
            this.data.trigger('valid:password', false, "パスワードは8~32文字(半角英数のみ)で入力して下さい")
            return;
          }
          if (v.password !== v.password2) {
            this.data.trigger('valid:password2', false, "パスワードが一致していません")
            return;
          }
          di.route.router.push("/confirm-information");
        }
        this.update();
      },
      prefs() {
        return window.__PREF_MASTERS__;
      },
      onChangeSelect(e) {
        this.data[e.target.name] = e.target.value;
        this.update();
      }
    }
  </script>
</input-information>